import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { supabase } from '../../../supabaseClient';
import { alertError } from '../../../components/Toast';
import DocumentPreviewModal from './DocumentPreviewModal';

// Botão compacto de anexo de documento (inline ao lado do input "Documento" no
// FinancialEntryModal). Aceita imagem e PDF, faz upload no bucket 'installment'
// em pasta documents/{company_id}/.
const DocumentAttach = ({ value, onChange, bucket = 'installment' }) => {
  const company = useSelector((state) => state.app.company || {});
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState('');
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const companyPrefix = company?.id ? `${company.id}/` : '';
      const path = `documents/${companyPrefix}${Date.now()}-${file.name}`;
      const { data, error } = await supabase.storage.from(bucket).upload(path, file);

      if (error) {
        alertError('Erro ao enviar documento.');
        return;
      }

      setFileName(file.name);
      onChange(data.Key || data.path || path);
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFileName('');
    onChange(null);
    if (inputRef.current) inputRef.current.value = '';
  };

  const hasFile = !!value;
  const displayName = fileName || (hasFile ? 'Documento anexado' : '');

  return (
    <div className="fd-doc-attach-wrapper">
      <input
        ref={inputRef}
        type="file"
        accept="image/*,.pdf"
        style={{ display: 'none' }}
        onChange={handleFileChange}
        aria-label="Selecionar documento"
      />
      {hasFile ? (
        <button
          type="button"
          className="fd-doc-attach fd-doc-attach--filled"
          onClick={() => setPreviewOpen(true)}
          title="Clique para visualizar o documento"
        >
          <span className="fd-doc-attach-icon">📄</span>
          <span className="fd-doc-attach-name">{displayName}</span>
          <span
            role="button"
            tabIndex={0}
            className="fd-doc-attach-remove"
            onClick={handleRemove}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') handleRemove(e);
            }}
            aria-label="Remover documento"
            title="Remover documento"
          >
            ✕
          </span>
        </button>
      ) : (
        <button
          type="button"
          className="fd-doc-attach"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          title="Anexar imagem ou PDF do documento"
        >
          {uploading ? '⏳ Enviando...' : '📎 Anexar'}
        </button>
      )}

      <DocumentPreviewModal
        isOpen={previewOpen}
        value={value}
        bucket={bucket}
        onClose={() => setPreviewOpen(false)}
      />
    </div>
  );
};

export default DocumentAttach;
